import MailTemplate        from "../../../../domain/mail/template/MailTemplate";
import MailTemplateContent from "../../../../domain/mail/template/MailTemplateContent";
import MailTemplateName    from "../../../../domain/mail/template/MailTemplateName";
import MailTemplateSubject from "../../../../domain/mail/template/MailTemplateSubject";
import ResKaReduxAction    from "../../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_MAIL_TEMPLATE = "SET_MAIL_TEMPLATE",
  SET_MAIL_TEMPLATE_NAME = "SET_MAIL_TEMPLATE_NAME",
  SET_MAIL_TEMPLATE_SUBJECT = "SET_MAIL_TEMPLATE_SUBJECT",
  SET_MAIL_TEMPLATE_CONTENT = "SET_MAIL_TEMPLATE_CONTENT",
}

export interface SetMailTemplateAction extends ResKaReduxAction {
  mailTemplate: MailTemplate;
}

export interface SetMailTemplateNameAction extends ResKaReduxAction {
  mailTemplateName: MailTemplateName;
}

export interface SetMailTemplateSubjectAction extends ResKaReduxAction {
  mailTemplateSubject: MailTemplateSubject;
}

export interface SetMailTemplateContentAction extends ResKaReduxAction {
  mailTemplateContent: MailTemplateContent;
}

export type MailTemplateAction =
  SetMailTemplateAction
  | SetMailTemplateNameAction
  | SetMailTemplateSubjectAction
  | SetMailTemplateContentAction;

export const setMailTemplateAction = (mailTemplate: MailTemplate): SetMailTemplateAction => ({
  type: ACTION_TYPE.SET_MAIL_TEMPLATE,
  mailTemplate: mailTemplate,
});

export const setMailTemplateNameAction = (mailTemplateName: MailTemplateName): SetMailTemplateNameAction => ({
  type: ACTION_TYPE.SET_MAIL_TEMPLATE_NAME,
  mailTemplateName: mailTemplateName,
});

export const setMailTemplateSubjectAction = (mailTemplateSubject: MailTemplateSubject): SetMailTemplateSubjectAction => ({
  type: ACTION_TYPE.SET_MAIL_TEMPLATE_SUBJECT,
  mailTemplateSubject: mailTemplateSubject,
});

export const setMailTemplateContentAction = (mailTemplateContent: MailTemplateContent): SetMailTemplateContentAction => ({
  type: ACTION_TYPE.SET_MAIL_TEMPLATE_CONTENT,
  mailTemplateContent: mailTemplateContent,
});